import { render } from "./changeLog.vue?vue&type=template&id=a117e346&scoped=true"
import script from "./changeLog.vue?vue&type=script&lang=js"
export * from "./changeLog.vue?vue&type=script&lang=js"

import "./changeLog.vue?vue&type=style&index=0&id=a117e346&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a117e346"]])

export default __exports__